import { useMediaQuery } from '@mui/material';

/**
 * True when the main input is a finger (phones, tablets, an iPad in the
 * desktop layout). Touch behavior must depend on this, not on screen width:
 * a 1200px+ tablet gets the desktop layout but has no hover, right click or
 * Delete key.
 */
export const useIsTouch = () =>
  useMediaQuery('(pointer: coarse)', { noSsr: true });
